import { Col, Form, Input, Row, Select, Button, notification, Switch } from 'antd';
import {
  CheckOutlined,
  CloseOutlined,
  EyeInvisibleOutlined,
  EyeTwoTone,
} from '@ant-design/icons';
import { useHistory, useParams } from 'react-router-dom';
import { UserService } from '../../sdk';
import { Usuarios } from '../../sdk/@types/Usuarios';
import jwtDecode from 'jwt-decode';
import { Authentication } from '../../auth/Auth';
import { userInfo } from 'os';
import { useCallback, useEffect, useState } from 'react';
import LojaService from '../../sdk/services/Loja.service';
import { Lojas } from '../../sdk/@types/Restaurantes';
import MaskedInput from 'antd-mask-input';
import { Option } from 'antd/lib/mentions';

export default function FormularioNovoTerminalComercial(props: {
  onSuccess: () => any;
  idLoja:string;
}) {
  const access_token = localStorage.getItem('accessToken');
  const parametroUrl = useParams<{ id: string }>();

  const decodedToken: Authentication.AccessTokenDecodedBody = jwtDecode(
    access_token as string
  );
  const [loading, setLoading] = useState(false);

  const { onSuccess } = props;

  const history = useHistory();

  return (
    <Form
      autoComplete={'off'}
      layout={'horizontal'}
      onFinish={async (novoTerminal: any) => {
        setLoading(true);
        try {
          let parametros ={
            pesquisaLivre: false,
            gerenciaEstoque: false,
            venderZerado: true,
            suprimir:true,
            atualizarProdutoNaVenda :true
          };
          const bodyNewTerminalComercial = {
            idRefTerminalFiscal: null,
            nome: novoTerminal.nome,
            parametros: JSON.stringify(parametros),
            idLoja: props.idLoja,
            tpAmb: '1'
          };
          await LojaService.postTerminalComercial(bodyNewTerminalComercial);

          onSuccess();
          setLoading(false);
        } catch (error) {
          setLoading(true);
        }
      }}
    >
      <Row align={'top'} gutter={24}>
        <Col xs={24} lg={24}>
          <Form.Item
            label={'Nome'}
            name={'nome'}
            rules={[
              {
                required: true,
                message: 'O campo é obrigatório',
              },
            ]}
          >
            <Input placeholder={'E.g.: 000'} />
          </Form.Item>
        </Col>

        <Col xs={24}>
          <Row justify={'end'}>
            <Button type={'primary'} htmlType={'submit'} loading={loading}>
              {'Salvar'}
            </Button>
          </Row>
        </Col>
      </Row>
    </Form>
  );
}
